import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';
import { b as bem } from './p-g1JgJ7wn.js';

const cosmosCarouselSlideCss = ":host{flex:0 0 auto;flex-basis:calc((100% - (var(--slide-size) - 1) * var(--slide-spacing)) / var(--slide-size));min-width:0}:host ::slotted(*){height:100%;width:100%}.cosmos-carousel-slide{height:100%;width:100%}.cosmos-carousel-slide__container{height:100%;width:100%}";

const generateClassNames = bem('cosmos-carousel-slide');
const CosmosCarouselSlide$1 = /*@__PURE__*/ proxyCustomElement(class CosmosCarouselSlide extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    render() {
        return (h(Host, { key: '469b2c02914855aaf807579386a6cbeca03c96cc', class: generateClassNames(), role: "group", "aria-roledescription": "slide" }, h("div", { key: 'd27caa33ffda7b57ef15d9f2769e955f6d89e72b', class: generateClassNames('container') }, h("slot", { key: '502cc010e911f30cc1fce74f25b9832da385d9bb' }))));
    }
    static get style() { return cosmosCarouselSlideCss; }
}, [1, "cosmos-carousel-slide"]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-carousel-slide"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-carousel-slide":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosCarouselSlide$1);
            }
            break;
    } });
}

const CosmosCarouselSlide = CosmosCarouselSlide$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosCarouselSlide, defineCustomElement };
